import Home from './components/home'
import Results from './components/results'
import JoinTeam from './components/joinTeam'
import CreatTeam from './components/creatTeam'
import AwardDistribution from './components/awardDistribution'
import EnqueueApproval from './components/enqueueApproval'
import Guide from './components/guide'
import MemberManage from './components/memberManage'
import RewardCollection from './components/rewardCollection'
import TeamBuild from './components/teamBuild'
import TeamExpansion from './components/teamExpansion'
import Warehouse from './components/warehouse'
import Leaderboard from './components/leaderboard'

import Dict from '@/utils/dict'

const { ROLES } = Dict
const { CAPTAIN, VICE_CAPTAIN, ELITE, ORDINARY, NONE } = ROLES

const menuConfig = [
  {
    key: '1',
    name: '战队首页',
    roles: [CAPTAIN, VICE_CAPTAIN, ELITE, ORDINARY],
    component: Home
  },
  {
    key: '2',
    name: '战队列表',
    roles: [CAPTAIN, VICE_CAPTAIN, ELITE, ORDINARY, NONE],
    component: JoinTeam
  },
  {
    key: '3',
    name: '创建战队',
    roles: [
      NONE
    ],
    component: CreatTeam
  },
  {
    key: '4',
    name: '比赛成绩',
    roles: [CAPTAIN, VICE_CAPTAIN, ELITE, ORDINARY, NONE],
    component: Results
  },
  {
    key: '5',
    name: '我的战队',
    roles: [CAPTAIN, VICE_CAPTAIN, ELITE, ORDINARY],
    children: [
      { key: '5_1', name: '战队建设', component: TeamBuild },
      { key: '5_2', name: '战队仓库', component: Warehouse },
      { key: '5_3', name: '英雄榜', component: Leaderboard },
    ]
  },
  {
    key: '6',
    name: '战队管理',
    roles: [CAPTAIN, VICE_CAPTAIN],
    children: [
      { key: '6_1', name: '成员管理', component: MemberManage },
      { key: '6_2', name: '入队审批', component: EnqueueApproval },
      { key: '6_3', name: '奖励发放', component: AwardDistribution },
      { key: '6_4', name: '奖励领取', component: RewardCollection },
      { key: '6_5', name: '战队扩容', component: TeamExpansion },
    ]
  },
  {
    key: '7',
    name: '公约指南',
    roles: [CAPTAIN, VICE_CAPTAIN, ELITE, ORDINARY, NONE],
    component: Guide
  },
]

export const noTeam = [
  { key: '1', name: '战队列表', component: JoinTeam },
  { key: '2', name: '创建战队', component: CreatTeam },
  { key: '3', name: '比赛成绩', component: Results },
  { key: '5', name: '公约指南', component: Guide },
]

export default menuConfig;
